// extracted by mini-css-extract-plugin
module.exports = {"popup":"PopupRoot-module__popup___25brp","closeButton":"PopupRoot-module__closeButton___1HdKG"};